module.exports = require('./lib/index');



//////////////////
// WEBPACK FOOTER
// ./~/react-hot-loader/index.js
// module id = ./node_modules/react-hot-loader/index.js
// module chunks = 0